'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _PlanScorecardFundIssueAccordion = require('./PlanScorecardFundIssueAccordion.css');

var _PlanScorecardFundIssueAccordion2 = _interopRequireDefault(_PlanScorecardFundIssueAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardFundIssueAccordion = (_dec = (0, _reactCssModules2.default)(_PlanScorecardFundIssueAccordion2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardFundIssueAccordion, _Component);

  function PlanScorecardFundIssueAccordion(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardFundIssueAccordion);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardFundIssueAccordion.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardFundIssueAccordion)).call(this, props));

    var fund = _this.props.fund;


    _this.state = {
      fund: fund,
      resultsConfig: {
        e: [{
          id: 'fff',
          site: 'Fossil Free Funds',
          name: 'Fossil fuels',
          grade: 'grade_fossil',
          description: 'Investments in coal, oil, and fossil gas energy and utility companies, and related financial companies'
        }, {
          id: 'dff',
          site: 'Deforestation Free Funds',
          name: 'Deforestation',
          grade: 'grade_deforestation',
          description: 'Investments in deforestation-risk agricultural commodities, and related financial companies and consumer brands'
        }],
        s: [{
          id: 'gef',
          site: 'Gender Equality Funds',
          name: 'Gender equality',
          grade: 'grade_gender_equality',
          description: 'Gender equality group ranking, based on Equileap company data'
        }, {
          id: 'gff',
          site: 'Gun Free Funds',
          name: 'Civilian firearms',
          grade: 'grade_guns',
          description: 'Investments in civilian firearms manufacturers, and related gun retailers'
        }, {
          id: 'pff',
          site: 'Prison Free Funds',
          name: 'Prison industrial complex',
          grade: 'grade_prison_industrial_complex',
          description: 'Investments in prisons and borders industry, including private prison operators'
        }, {
          id: 'wff',
          site: 'Weapon Free Funds',
          name: 'Military weapons',
          grade: 'grade_military',
          description: 'Investments in military arms manufacturers and services companies, including nuclear weapon manufacturers and servicers'
        }, {
          id: 'tff',
          site: 'Tobacco Free Funds',
          name: 'Tobacco',
          grade: 'grade_tobacco',
          description: 'Investments in tobacco and e-cigarette manufacturers, and tobacco-promoting entertainment companies'
        }]
      }
    };
    return _this;
  }

  //


  (0, _createClass3.default)(PlanScorecardFundIssueAccordion, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          fund = _state.fund,
          resultsConfig = _state.resultsConfig;

      //

      if (fund.percent_rated_long <= 0.5) {
        return _react2.default.createElement(
          'div',
          { styleName: 'not-rated-panel' },
          _react2.default.createElement(
            'h3',
            { styleName: 'not-rated-headline' },
            'Not rated'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Not rated - this fund was not rated because it is less than 40% invested in stock holdings.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.methodology,
                xstrong: true,
                title: 'Methodology'
              },
              'Read more about our rating methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }

      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { styleName: 'th' },
          'Environment'
        ),
        resultsConfig.e.map(function (el, idx) {
          return _react2.default.createElement(_components.PlanScorecardFundIssueAccordionItem, {
            key: 'accordion-item-e-' + idx,
            fund: fund,
            el: el,
            idx: idx
          });
        }),
        _react2.default.createElement(
          'h3',
          { styleName: 'th' },
          'Social'
        ),
        resultsConfig.s.map(function (el, idx) {
          return _react2.default.createElement(_components.PlanScorecardFundIssueAccordionItem, {
            key: 'accordion-item-s-' + idx,
            fund: fund,
            el: el,
            idx: idx
          });
        })
      );
    }
  }]);
  return PlanScorecardFundIssueAccordion;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardFundIssueAccordion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardFundIssueAccordion/PlanScorecardFundIssueAccordion.js
// module id = 1416
// module chunks = 0